import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PAGE_TITLE } from '../../../config/constants';
import css from './QuickActionsAndContact.module.scss';
import Form from './Form';
import QuickActions from './QuickActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var QuickActionsAndContact = function QuickActionsAndContact(_ref) {
  var categories = _ref.categories;
  // Hook to change the page title
  useEffect(function () {
    document.title = "Help Center".concat(PAGE_TITLE);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(QuickActions, {}), /*#__PURE__*/_jsxs("div", {
      className: css.form,
      children: [/*#__PURE__*/_jsx("h3", {
        className: css.formTitle,
        children: "Still have questions? Get in touch."
      }), /*#__PURE__*/_jsx(Form, {
        categories: categories
      })]
    })]
  });
};

QuickActionsAndContact.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({}))
};
export default QuickActionsAndContact;